import {connectorTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = connectorTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const connectorReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default connectorReducer;
